/** The trailing windows the health page can aggregate over; the endpoint accepts exactly these. */
export const WINDOW_DAYS_OPTIONS = [7, 30] as const;
export type WindowDays = (typeof WINDOW_DAYS_OPTIONS)[number];
